import React, { useEffect, useState } from "react";
import WorkingPartDetailTimeline from "./workingPartDetail.timeline.view";
import * as WorkingPartService from "../../../../services/WorkingPartServices";
import showDialog from "../../../utils/ShowDialog/ShowDialog";
import { useTranslation } from "react-i18next";
import * as ConceptService from "../../../../services/ConceptServices";

const WorkingPartDetailContainer = ({ uuid }) => {
  const [data, setData] = useState(null);
  const [dataConcept, setDataConcept] = useState(null);
  const [dataConcepts, setDataConcepts] = useState(null);
  const [forceRefresh, setForceRefresh] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    if (uuid) {
      WorkingPartService.getWorkingPartByUuid(uuid).then((result) => {
        setData(result);
      });
      ConceptService.getConceptByUuid(uuid).then((result) => {
        setDataConcept(result);
      });
      ConceptService.getAllConcepts(uuid).then((result) => {
        setDataConcepts(result);
        console.log(result);
      });
    }
  }, [uuid]);

  const handleUpdateDays = async (nifSociety, days) => {
    if (uuid) {
      const result = await WorkingPartService.updateDaysBySociety(
        uuid,
        nifSociety,
        days,
      );

      if (result) {
        WorkingPartService.getWorkingPartByUuid(uuid).then((updatedResult) => {
          setData(updatedResult);
        });
      }
      return result;
    }
    return null;
  };

  const renderConceptsMessage = (data) => {
    let message = t("forms.workingPartDetail.dialog.closeProcess.message");
    data.societies.forEach((society) => {
      message += `\n- ${society.name}: ${society.concepts.length} ${t(
        "forms.workingPartDetail.dialog.closeProcess.concepts",
      )}`;
    });
    return message;
  };

  const sendA3Concepts = async () => {
    let title = t("forms.workingPartDetail.dialog.closeProcess.title");
    let text = renderConceptsMessage(data);

    let okAction = async () => {
      try {
        let result = await WorkingPartService.sendWorkingPartToA3({
          snapshotUuid: data.uuid,
        });

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          title = t("forms.workingPartDetail.messages.finish.title");
          text = t("forms.workingPartDetail.messages.finish.success");
          icon = "success";
          showDialog(title, text, icon, false, "OK", false);
        } else {
          title = "Error";
          text = t("forms.workingPartDetail.messages.finish.error");
          icon = "error";
          showDialog(title, text, icon, false, "OK", false);
        }
      } catch (error) {
        const errorCode = error.data.error.code;
        let errorMsg;
        let title = "Error";
        let icon = "error";

        if (errorCode === "DATE.ERROR") {
          errorMsg = t("forms.workingPartDetail.messages.finish.dateError");
        } else {
          errorMsg = t("forms.workingPartDetail.messages.finish.error");
        }

        showDialog(title, errorMsg, icon, false, "OK", false);
      }
    };

    const cancelAction = () => {};

    showDialog(
      title,
      text,
      "warning",
      true,
      t("forms.inventary.dialog.closeProcess.buttonOk"),
      false,
      okAction,
      t("forms.inventary.dialog.closeProcess.buttonNo"),
      cancelAction,
    );
  };

  return (
    <WorkingPartDetailTimeline
      data={data}
      uuid={uuid}
      onUpdateDays={handleUpdateDays}
      dataConcept={dataConcept}
      dataConcepts={dataConcepts}
      onForceRefresh={() => setForceRefresh(true)}
    />
  );
};

WorkingPartDetailContainer.propTypes = {};

export default WorkingPartDetailContainer;
